import { PRODUCT_CATEGORY } from '@schuettflix/interfaces';

export const PRODUCT_CATEGORY_LABEL = {
    MATERIAL: 'product.category.label.material',
    TRANSPORT: 'product.category.label.transport',
    MATERIAL_SERVICE: 'product.category.label.custom',
    TRANSPORT_SERVICE: 'product.category.label.custom',
} as const satisfies Record<PRODUCT_CATEGORY, string>;
